













































import { PropType } from 'vue';
import { defineComponent, toRefs, ref, computed, watch } from '@vue/composition-api';
import { AdgroupFormData, CampaignFormData } from '@tt4b/ttam-enums';
import { isEqual } from 'lodash-es';
import { useGetInterestBehaviorCategory, loadHashTagsInfo, useGetInterestKeywordsInfo } from './hooks';
import { useBehaviorData } from './../../../hooks/creation/adgroup/useBehavior/index';
import InterestBehaviorSearchBox from './components/search-box.vue';
import LearnMore from '@/components/common/learn-more/index.vue';
import RecommendTarget from './components/recommend-target.vue';
import HashtagPreOffline from './components/hashtag-pre-offline.vue';
import OfflineTags from './components/offline-tags.vue';
const name = 'ttam-interests-five-in-one-compose';
export default defineComponent({
  name,
  components: {
    LearnMore,
    InterestBehaviorSearchBox,
    RecommendTarget,
    HashtagPreOffline,
    OfflineTags,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    showRecommend: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  // eslint-disable-next-line max-lines-per-function
  setup(props, { emit }) {
    const { adgroupData, campaignData } = toRefs(props);
    const hashtagPreRef = ref();
    const offlineRef = ref();
    const change = function (data) {
      emit('change-interests', data);
    };
    const { run: loadInterestBehaviorCategory } = useGetInterestBehaviorCategory({
      campaignData,
      adgroupData,
    });
    const { hashtagCategories } = useBehaviorData({
      adgroupData,
    });
    const params = computed(() => ({
      inventory: adgroupData.value.inventoryFlow,
      industryTypes: campaignData.value.industryTypes,
    }));
    const loadBehaviorInfo = async function () {
      // 获取兴趣，行为的数据
      await loadInterestBehaviorCategory();
      // 获取兴趣关键词
      useGetInterestKeywordsInfo({
        campaignData,
        adgroupData,
      }).then(list => {
        // 处理下线的兴趣词
        offlineRef.value?.handleInterestKeywordsOffline(list);
      });
      // 获取hashtag
      loadHashTagsInfo(hashtagCategories.value || []).then(list => {
        // 处理即将下线/下线的hashtag
        offlineRef.value?.handleHashtagOffline(list);
        hashtagPreRef.value?.handlePreOfflineHashTag(list);
      });
    };

    watch(
      params,
      (val, oldVal) => {
        // 深比较，避免多次请求
        if (!isEqual(val, oldVal)) {
          loadBehaviorInfo();
        }
      },
      {
        immediate: true,
      },
    );
    return {
      name,
      hashtagPreRef,
      offlineRef,
      change,
    };
  },
});
